import date from './Date';

export default {
  tin: function (tin) {
    let convertValue = '';
    if (tin != null && tin.length === 9) {
      let frontValue = tin.substring(0, 3);
      let middleValue = tin.substring(3, 6);
      let endValue = tin.substring(6, 9);
      convertValue = frontValue + '-' + middleValue + '-' + endValue;
    } else {
      convertValue = tin;
    }
    return convertValue;
  },
  uniqueInvoiceIdFormat(uniquInvoiceId) {
    if (!uniquInvoiceId) {
      return '-';
    }

    let str1 = uniquInvoiceId.substring(0, 8);
    let str2 = uniquInvoiceId.substring(8, 16);
    let str3 = uniquInvoiceId.substring(16, 24);
    let result = str1 + '-' + str2 + '-' + str3;

    return result;
  },
  uniqueInvoiceIdResetFormat(uniquInvoiceId) {
    uniquInvoiceId.replaceAll('-', '');
    return uniquInvoiceId;
  },
  issueStatusCodeFormat(issueStatusCode) {
    if (issueStatusCode === '01') {
      issueStatusCode = 'On Hold';
    } else if (issueStatusCode === '02') {
      issueStatusCode = 'Requesting';
    } else if (issueStatusCode === '03') {
      issueStatusCode = 'Completed';
    } else if (issueStatusCode === '04') {
      issueStatusCode = 'Error';
    } else {
      issueStatusCode = 'On Hold';
    }
    return issueStatusCode;
  },
  correctionCodeFormat(correctionCodeFormat) {
    if (correctionCodeFormat === '01') {
      correctionCodeFormat = 'Error';
    } else if (correctionCodeFormat === '02') {
      correctionCodeFormat = 'Addition/Reduction';
    } else if (correctionCodeFormat === '03') {
      correctionCodeFormat = 'Cancellration';
    } else if (correctionCodeFormat === '04') {
      correctionCodeFormat = 'Dupplication';
    } else if (correctionCodeFormat === '05') {
      correctionCodeFormat = 'Return';
    } else if (correctionCodeFormat === '06') {
      correctionCodeFormat = 'Others(specify)';
    } else {
      correctionCodeFormat = '';
    }
    return correctionCodeFormat;
  },
  emailCodeFormat(rstateCode) {
    if (rstateCode === 0) {
      rstateCode = 'Success';
    } else if (rstateCode === 1) {
      rstateCode = 'Success(OK)';
    } else if (rstateCode === -1) {
      rstateCode = 'Sending';
    } else if (rstateCode === 10) {
      rstateCode = 'Error : Hour/Day Limit Over for Relaying Mail';
    } else if (rstateCode === 29) {
      rstateCode = 'Error : DNS Lookup Fail';
    } else if (rstateCode === 30) {
      rstateCode = 'Error : Unknown Host Fail';
    } else if (rstateCode === 31) {
      rstateCode = 'Error :  Socket Connection Fail';
    } else if (rstateCode === 32) {
      rstateCode = 'Error : Socket Input/Output Fail';
    } else if (rstateCode === 33) {
      rstateCode = 'Error : Receive Mail Server Not Ready';
    } else if (rstateCode === 39) {
      rstateCode = 'Error : RelayMail Denied To MailServer For Loop Error';
    } else if (rstateCode === 41) {
      rstateCode = 'Error : SMTP Command(HELO,EHLO) Process Fail';
    } else if (rstateCode === 42) {
      rstateCode = 'Error : SMTP Command(MAIL FROM) Process Fail';
    } else if (rstateCode === 43) {
      rstateCode = 'Error : SMTP Command(RCPT TO) Process Fail';
    } else if (rstateCode === 44) {
      rstateCode = 'Error : SMTP Command(DATA) Process(1) Fail';
    } else if (rstateCode === 45) {
      rstateCode = 'Error : SMTP Command(DATA) Process(2) Fail';
    } else if (rstateCode === 61) {
      rstateCode = 'Error : Relaying Denied(Zmail)';
    } else if (rstateCode === 62) {
      rstateCode = 'Error : Receive Denied(Zmail)';
    } else if (rstateCode === 63) {
      rstateCode = 'Error : User Unknown(Zmail)';
    } else if (rstateCode === 64) {
      rstateCode = 'Error : User Storage Over(Zmail)';
    } else if (rstateCode === 88) {
      rstateCode = 'Error : Null Pointer Exception';
    } else if (rstateCode === 99) {
      rstateCode = 'Error : Other Exception Fail';
    } else {
      rstateCode = 'N/A';
    }
    return rstateCode;
  },
  issueDateFormat(issueDate) {
    if (!issueDate || issueDate.length != 14) {
      return '-';
    }

    let str1 = issueDate.substring(0, 4);
    let str2 = issueDate.substring(4, 6);
    let str3 = issueDate.substring(6, 8);
    let str4 = issueDate.substring(8, 10);
    let str5 = issueDate.substring(10, 12);
    let str6 = issueDate.substring(12, 14);
    let result =
      str1 + '-' + str2 + '-' + str3 + ' ' + str4 + ':' + str5 + ':' + str6;

    return result;
  },
  applicationTypeFormat(applicationType) {
    switch (applicationType) {
      case '10':
        applicationType = 'EIS';
        break;
      case '20':
        applicationType = 'CAS';
        break;
      case '31':
        applicationType = 'POS';
        break;
      case '32':
        applicationType = 'CRM';
        break;
      case '51':
        applicationType = 'ASP-CAS';
        break;
      case '52':
        applicationType = 'ASP-POS';
        break;
    }
    return applicationType;
  },
  transactionClassificationForamt(transactionClassification) {
    switch (transactionClassification) {
      case '01':
        transactionClassification = 'VATable';
        break;
      case '02':
        transactionClassification = 'VAT Zero-Rated';
        break;
      case '03':
        transactionClassification = 'VAT-Exempt';
        break;
    }
    return transactionClassification;
  },
  documentTypeCodeFormat(documentTypeCode) {
    switch (documentTypeCode) {
      case '01':
        documentTypeCode = 'SI';
        break;
      case '02':
        documentTypeCode = 'OR';
        break;
      case '03':
        documentTypeCode = 'SB';
        break;
      case '04':
        documentTypeCode = 'CM';
        break;
      case '05':
        documentTypeCode = 'DM';
        break;
      case '06':
        documentTypeCode = 'Void/Return/Cancel slip,etc';
        break;
    }
    return documentTypeCode;
  },
  applicationTypeFormat(applicationType) {
    switch (applicationType) {
      case '10':
        applicationType = 'WEB';
        break;
      case '20':
        applicationType = 'CAS';
        break;
      case '31':
        applicationType = 'POS';
        break;
      case '32':
        applicationType = 'CRM';
        break;
      case '51':
        applicationType = 'ASP-CAS';
        break;
      case '52':
        applicationType = 'ASP-POS';
        break;
    }
    return applicationType;
  },
  sellerTypeCodeFormat(sellerTypeCode) {
    switch (sellerTypeCode) {
      case '0':
        sellerTypeCode = 'VAT';
        break;
      case '1':
        sellerTypeCode = 'Non-VAT';
        break;
    }
    return sellerTypeCode;
  },
  correctionYnForamt(correctionYn) {
    return correctionYn == 'N' ? 'General' : 'Correction';
  },
  /**
   * [임시] 코드변환
   */
  codeTrans(param) {
    param.issuanceDate = date.dateConvert(param.issuanceDate);
    param.transactionClassification = this.transactionClassificationForamt(
      param.transactionClassification
    );
    param.documentTypeCode = this.documentTypeCodeFormat(
      param.documentTypeCode
    );
    param.applicationType = this.applicationTypeFormat(param.applicationType);
    param.sellerTypeCode = this.sellerTypeCodeFormat(param.sellerTypeCode);
    param.correctionYn = this.correctionYnForamt(param.correctionYn);

    param.issuanceTimestamp = date.dateConvert(param.issuanceTimestamp);
    param.transactionTimestamp = date.dateConvert(param.transactionTimestamp);
    param.totalAmount = param.totalNetItemSalesAmount + param.vatAmount;

    if (param.invoiceBuyerDto) {
      param.invoiceBuyerDto.tin = this.tin(param.invoiceBuyerDto.tin);
    } else if (param.invoiceBuyerTempDto) {
      param.invoiceBuyerTempDto.tin = this.tin(param.invoiceBuyerTempDto.tin);
    } else {
    }

    param.sellerTin = this.tin(param.sellerTin);
    param.uniqueInvoiceId = this.uniqueInvoiceIdFormat(param.uniqueInvoiceId);

    return param;
  },
};
